import Vue from 'vue';
import axios from 'axios';
import App from './App.vue';
import './registerServiceWorker';
import jwtDecode from 'jwt-decode';
import router from './router';
import { API_URL } from '@/config';
import vueScrollTo from 'vue-scrollto';
import moment from 'moment';

Vue.config.productionTip = false;

Vue.prototype.$axios = axios;
Vue.prototype.$decode = jwtDecode;
Vue.prototype.$API_URL = API_URL;

Vue.use(vueScrollTo);

Vue.filter('filterTimeFromDate', function(value) {
    if (value) {
      return moment(String(value)).format('HH:mm');
    }
});

Vue.filter('filterDateTimeFromDate', function(value) {
    if (value) {
      return moment(String(value)).format('D.M. HH:mm');
    }
});

axios.interceptors.request.use(config => {
        config.headers.Authorization = `Bearer ${localStorage.getItem('token')}`;
        return config;
    },
    error => {
        Promise.reject(error);
    });

axios.interceptors.response.use(response => {
    return response;
}, error => {
    let originalRequest = error.config;
    if (error.response && error.response.status === 401 && !originalRequest._retry && localStorage.getItem('token')) {
        originalRequest._retry = true;
        return axios.post(`${API_URL}/login/new`,
            {
                token: localStorage.getItem('token')
            }).then(response => {
            localStorage.setItem('token', response.data);
            return axios(originalRequest);
        });
    }
    else if (error.response && error.response.status === 401 && originalRequest._retry) {
        localStorage.removeItem('token');
        window.location.href = '/';
        return;
    }
    return Promise.reject(error);
});

new Vue({
    router,
    render: h => h(App)
}).$mount('#app');